import React, { useEffect } from "react";
import { Box, Flex, Button, IconButton, Image, Text } from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

const PopupModal = ({
  showPopup,
  popupData,
  currentPopupIndex,
  onClose,
  onHideFor24Hours,
  onIndexChange,
}) => {
  const navigate = useNavigate();
  // 자동 슬라이드 (5초마다)
  useEffect(() => {
    if (showPopup && popupData.length > 1) {
      const interval = setInterval(() => {
        onIndexChange((prev) => (prev === popupData.length - 1 ? 0 : prev + 1));
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [showPopup, popupData.length, onIndexChange]);

  if (!showPopup || popupData.length === 0) {
    return null;
  }

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bg="rgba(0, 0, 0, 0.7)"
      zIndex={9999}
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={4}
      onClick={onClose}
    >
      <Box
        position="relative"
        maxW={{ base: "330px", md: "528px", lg: "660px" }}
        w="90%"
        bg="rgb(26, 26, 26)"
        borderRadius="2xl"
        overflow="hidden"
        boxShadow="2xl"
        onClick={(e) => e.stopPropagation()}
        cursor="default"
      >
        {/* 팝업 이미지 */}
        <Box
          position="relative"
          h={{ base: "250px", md: "400px", lg: "500px" }}
          overflow="hidden"
          my={{ base: 4, md: 6, lg: 8 }}
          cursor="pointer"
          onClick={() => {
            if (popupData[currentPopupIndex]?.page_url) {
              // 현재 브라우저 창에서 페이지 이동
              navigate(popupData[currentPopupIndex].page_url);
              onClose(); // 팝업 닫기
            }
          }}
          _hover={{
            opacity: 0.9,
            transition: "opacity 0.2s",
          }}
        >
          <Image
            src={popupData[currentPopupIndex]?.img_url}
            alt="팝업 이미지"
            w="100%"
            h="100%"
            objectFit="cover"
            onError={(e) => {
              e.target.src = "/images/youtube-play.png";
            }}
          />
          {/* 클릭 가능 표시 */}
          {popupData[currentPopupIndex]?.page_url && (
            <Box
              position="absolute"
              bottom={2}
              right={2}
              bg="rgba(0, 0, 0, 0.3)"
              color="white"
              px={2}
              py={1}
              borderRadius="md"
              fontSize="xs"
              fontWeight="medium"
            >
              클릭하여 이동
            </Box>
          )}
        </Box>

        {/* 인디케이터 */}
        {popupData.length > 1 && (
          <Box
            position="absolute"
            bottom={0}
            left={0}
            right={0}
            bg="rgba(0, 0, 0, 0.0)"
            py={{ base: 2, md: 4 }}
            display="flex"
            justifyContent="center"
          >
            <Flex gap={{ base: 2, md: 3 }}>
              {popupData.map((_, index) => (
                <Box
                  key={index}
                  w={{ base: 1.5, md: 2 }}
                  h={{ base: 1.5, md: 2 }}
                  borderRadius="full"
                  bg={
                    index === currentPopupIndex
                      ? "white"
                      : "rgba(255, 255, 255, 0.5)"
                  }
                  cursor="pointer"
                  onClick={() => onIndexChange(index)}
                  transition="all 0.3s"
                  _hover={{
                    bg:
                      index === currentPopupIndex
                        ? "white"
                        : "rgba(255, 255, 255, 0.8)",
                    transform: "scale(1.1)",
                  }}
                  boxShadow="sm"
                />
              ))}
            </Flex>
          </Box>
        )}

        {/* 상단 버튼들 */}
        <Flex
          position="absolute"
          top={{ base: 2, md: 4 }}
          right={{ base: 2, md: 4 }}
          gap={{ base: 1, md: 2 }}
        >
          {/* 24시간 보지 않기 버튼 */}
          <Button
            size={{ base: "xs", md: "sm" }}
            variant="ghost"
            bg="rgba(140, 140, 140, 0.5)"
            color="white"
            borderRadius="full"
            fontSize={{ base: "4xs", md: "2xs" }}
            fontWeight="medium"
            px={{ base: 2, md: 3 }}
            h={{ base: "20px", md: "24px" }}
            _hover={{
              bg: "rgba(80, 80, 80, 0.8)",
              transform: "scale(1.05)",
              boxShadow: "md",
            }}
            transition="all 0.2s"
            onClick={onHideFor24Hours}
          >
            24시간 보지 않기
          </Button>

          {/* 닫기 버튼 */}
          <IconButton
            icon={<CloseIcon boxSize={3} />}
            onClick={onClose}
            aria-label="팝업 닫기"
            bg="rgba(140, 140, 140, 0.5)"
            color="white"
            size={{ base: "4xs", md: "2xs" }}
            borderRadius="full"
            boxShadow="lg"
            h={{ base: "24px", md: "24px" }}
            w={{ base: "24px", md: "24px" }}
            _hover={{
              bg: "rgba(80, 80, 80, 0.8)",
              transform: "scale(1.1)",
              boxShadow: "xl",
            }}
            transition="all 0.2s"
          />
        </Flex>
      </Box>
    </Box>
  );
};

export default PopupModal;
